// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__qwXNW","control":"Checkout_control__WDkHm","actions":"Checkout_actions__uIE12","submit":"Checkout_submit__Exd+C","invalid":"Checkout_invalid__RvmG0"};